import { styled } from '@mui/system'
import Button from '../../molecules/button/button'
import Dialog from '../../molecules/dialog'

export const Root = styled('span')``

export const ButtonStyled = styled(Button)``

export const DialogStyled = styled(Dialog)``
